const initState = {
  departments: []
}

const departmentReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_DEPARTMENTS': 
      return {
        ...state, 
        departments: action.departments 
      }
    default: 
      return state;
  }
}

export default departmentReducer
